import { Injectable } from '@angular/core';

const STORAGE_PREFIX = 'current:';

@Injectable({ providedIn: 'root' })
export class CurrentValueService {
  private cache = new Map<string, any>();

  set(key: string, value?: any) {
    if (value === undefined) {
      this.cache.delete(key);
      sessionStorage.removeItem(STORAGE_PREFIX + key);
      return;
    }
    this.cache.set(key, value);
    sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
  }

  get<T = any>(key: string): T | undefined {
    if (this.cache.has(key)) return this.cache.get(key);
    const raw = sessionStorage.getItem(STORAGE_PREFIX + key);
    if (!raw) return undefined;
    try {
      const parsed = JSON.parse(raw);
      this.cache.set(key, parsed);
      return parsed as T;
    } catch {
      sessionStorage.removeItem(STORAGE_PREFIX + key);
      return undefined;
    }
  }

  clear(key: string) {
    this.cache.delete(key);
    sessionStorage.removeItem(STORAGE_PREFIX + key);
  }

  clearAll(prefix?: string) {
    this.cache.clear();
    if (!prefix) {
      Object.keys(sessionStorage).forEach(k => {
        if (k.startsWith(STORAGE_PREFIX)) sessionStorage.removeItem(k);
      });
    } else {
      Object.keys(sessionStorage).forEach(k => {
        if (k.startsWith(STORAGE_PREFIX + prefix)) sessionStorage.removeItem(k);
      });
    }
  }
}
